import React from "react";
import { observer } from "mobx-react";

function CurrentDilutionTestStatus({ dilutionTest }) {
  if (!dilutionTest || !dilutionTest.input_count) return null;

  return (
    <div className="current_count">
      <div className="test_name">{dilutionTest.test_name}</div>
      <div className="count">{dilutionTest && dilutionTest.input_count}</div>
      <div className="info">press enter to save this count</div>
    </div>
  );
}

export default observer(CurrentDilutionTestStatus);
